const topicItems = [
  { name: '娱乐圈爆料', heat: '128万帖', icon: 'ri-movie-line' },
  { name: '网红翻车', heat: '96万帖', icon: 'ri-user-unfollow-line' },
  { name: '互联网大厂', heat: '85万帖', icon: 'ri-building-line' },
  { name: '明星恋情', heat: '73万帖', icon: 'ri-heart-2-line' },
  { name: '直播圈内幕', heat: '67万帖', icon: 'ri-live-line' },
  { name: '综艺节目', heat: '58万帖', icon: 'ri-tv-line' },
  { name: '社会热点', heat: '52万帖', icon: 'ri-fire-line' },
  { name: '金融八卦', heat: '45万帖', icon: 'ri-money-dollar-circle-line' },
  { name: '体育圈', heat: '39万帖', icon: 'ri-basketball-line' },
  { name: '电竞吃瓜', heat: '34万帖', icon: 'ri-gamepad-line' },
  { name: '时尚圈', heat: '28万帖', icon: 'ri-shirt-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            热门话题
          </h2>
          <span className="text-xs text-foreground-500 mt-1">11个热议话题</span>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="inline-flex items-center gap-2.5 px-4 py-2.5 bg-background-100 hover:bg-background-200 rounded-xl transition-colors cursor-pointer group border border-background-200/50"
            >
              <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-primary-400 text-base`}></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-300 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                  {item.name}
                </div>
                <div className="text-xs text-foreground-600">{item.heat}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}